import React, { useState } from 'react';
import useGameService from 'services/GameService';

import ActionButton, { HAND_END_BUTTON_MAX_WIDTH } from './ActionButton';

const MuckCard = () => {
  const { muckCard } = useGameService();
  // Hide immediately on click for instant feedback (see ShowCard for rationale).
  const [clicked, setClicked] = useState(false);

  if (clicked) return null;

  const handleClick = () => {
    setClicked(true);
    muckCard();
  };

  return (
    <ActionButton
      variant='fold'
      icon='fold'
      maxWidth={HAND_END_BUTTON_MAX_WIDTH}
      onClick={handleClick}>
      Muck Cards
    </ActionButton>
  );
};

export default MuckCard;
